module.exports = {
	"id": "LT",
	"name": "Lithuania",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.016806,
			"7": null,
			"8": null,
			"9": 0.016806,
			"10": null,
			"11": 0.016806,
			"12": 0.016806,
			"13": 0.008403,
			"14": 0.016806,
			"15": 0.008403,
			"16": 0.025209,
			"17": 0.016806,
			"18": 0.831897,
			"19": 0.033612,
			"20": 0.016806,
			"21": 0.025209,
			"22": 0.042015,
			"23": 0.050418,
			"24": 0.025209,
			"25": 0.050418,
			"26": 0.033612,
			"27": null,
			"28": 0.008403,
			"29": 0.008403,
			"30": 0.016806,
			"31": 0.042015,
			"32": 0.025209,
			"33": 0.016806,
			"34": 0.033612,
			"35": 0.050418,
			"36": 0.016806,
			"37": 0.025209,
			"38": 0.050418,
			"39": 0.092433,
			"40": 0.042015,
			"41": 0.025209,
			"42": 0.050418,
			"43": 0.798285,
			"44": 0.050418,
			"45": 0.033612,
			"46": 0.042015,
			"47": 0.067224,
			"48": 0.126045,
			"49": 2.378049,
			"50": 1.193226,
			"51": 7.81479,
			"52": 0.563001,
			"53": 24.998925,
			"54": 6.713997,
			"55": 0.100836,
			"56": 0.025209,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.033612,
			"4": 0.016806,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.008403,
			"10": null,
			"11": 0.025209,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.008403,
			"16": 0.008403,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.016806,
			"21": 0.008403,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.008403,
			"29": 0.016806,
			"30": 0.008403,
			"31": 0.033612,
			"32": 0.008403,
			"33": 0.008403,
			"34": 0.025209,
			"35": 0.033612,
			"36": 0.025209,
			"37": 0.033612,
			"38": 0.33612,
			"39": 0.042015,
			"40": 0.033612,
			"41": 0.042015,
			"42": 0.058821,
			"43": 0.815091,
			"44": 0.067224,
			"45": 0.663837,
			"46": 0.722658,
			"47": 3.386409,
			"48": 1.142808,
			"49": 10.797855,
			"50": 0.134448,
			"51": null,
			"52": null,
			"3.5": 0.067224,
			"3.6": 0.159657
		},
		"opera": {
			"9": null,
			"11": 0.008403,
			"12": 0.067224,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.016806,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.016806,
			"27": 0.033612,
			"28": 0.016806,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.008403,
			"35": 0.033612,
			"36": 0.134448,
			"37": 0.050418,
			"38": 1.453719,
			"39": 0.08403,
			"40": 2.277213,
			"41": 0.344523,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.016806,
			"10.5": null,
			"10.6": 0.025209,
			"11.1": 0.025209,
			"11.5": 0.016806,
			"11.6": 0.058821,
			"12.1": 0.25209
		},
		"safari": {
			"0": null,
			"4": 0.025209,
			"5": 0.042015,
			"6": null,
			"7": 0.025209,
			"8": 0.08403,
			"9": 0.126045,
			"10": 0.873912,
			"3.1": null,
			"3.2": null,
			"5.1": 0.058821,
			"6.1": 0.033612,
			"7.1": null,
			"9.1": 0.689046
		},
		"ios_saf": {
			"8": 0,
			"10": 1.95401828143,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0526585316403,
			"8.1-8.4": 0.0972844059117,
			"9.0-9.2": 0.0464109092423,
			"9.3": 0.708063871774
		},
		"android": {
			"3": 0,
			"4": 0.0157331782946,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00196664728682,
			"4.1": 0.0567518217054,
			"4.2-4.3": 0.141879554264,
			"4.4": 0.325339651163,
			"4.4.3-4.4.4": 0.328149147287
		},
		"ie": {
			"6": 0.0169215051546,
			"7": 0.00846075257732,
			"8": 0.245361824742,
			"9": 0.169215051546,
			"10": 0.25382257732,
			"11": 4.23037628866,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0258651297214,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000718475825594
		},
		"edge": {
			"12": 0.067224,
			"13": 0.865509,
			"14": 1.201629
		},
		"ie_mob": {
			"10": 0.0789907605634,
			"11": 0.321605239437
		},
		"bb": {
			"7": 0.004389,
			"10": null
		},
		"samsung": {
			"0": 2.504124
		},
		"and_uc": {
			"0": 0.094164
		},
		"op_mini": {
			"0": 0.348476394453
		},
		"and_chr": {
			"0": 9.309888
		},
		"and_ff": {
			"0": 0.028728
		}
	},
	"total": 95.861958
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LT.json
 ** module id = 578
 ** module chunks = 0
 **/